import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input-container mb-6" }
const _hoisted_2 = { class: "input-label flex" }
const _hoisted_3 = {
  key: 0,
  class: "text-error"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", { class: "block text-center" }, "Przykłady:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc mt-2 ml-4 text-left" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "" }, "Pracuję fizycznie – magazyn, dźwiganie ciężarów"),
  /*#__PURE__*/_createElementVNode("li", { class: "" }, "Praca biurowa – komputer, siedzenie przez wiele godzin"),
  /*#__PURE__*/_createElementVNode("li", { class: "" }, "Kierowca zawodowy – długie trasy, prowadzenie auta"),
  /*#__PURE__*/_createElementVNode("li", { class: "" }, "Praca w sklepie – obsługa klientów, stanie przez wiele godzin"),
  /*#__PURE__*/_createElementVNode("li", { class: "" }, "Praca w gastronomii – kelnerka, kuchnia, dużo chodzenia i dźwigania")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}

import { useField, Field } from 'vee-validate';
import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'YourRoleInWork',
  props: {
    isRequired: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: 'Czym zajmujesz się w pracy?',
    },
    placeholder: {
        type: String,
        default:
            'Wpisz rodzaj wykonywanej pracy / obowiązki zawodowe',
    },
    classes: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;



const { value, errors, errorMessage } = useField('yourRoleInWork');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      (__props.isRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "* "))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "(opcjonalne)")),
      _createVNode(TooltipButton, null, {
        default: _withCtx(() => []),
        tooltip: _withCtx(() => [
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Field), {
      name: "yourRoleInWork",
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
      type: "text",
      placeholder: __props.placeholder,
      class: _normalizeClass(["form-input", {
          'border-[1px] border-error border-solid': _unref(errors).length,
          'border-none': !_unref(errors).length,
          [__props.classes]: true
        }])
    }, null, 8, ["modelValue", "placeholder", "class"]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}